import {
  CREATEFINANCESETUP,
  DELETEFINANCESETUP,
  GETFINANCESETUP,
  UPDATEFINANCESETUP,
} from "../actions/types";

const initialState = {
  financeSetupList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEFINANCESETUP:
      return {
        ...state,
        financeSetupSaveStatus: action.payload.success,
      };

    case GETFINANCESETUP:
      return {
        ...state,
        financeSetupList: action.payload.data,
      };

    case UPDATEFINANCESETUP:
      return {
        ...state,
        financeSetupUpdateStatus: action.payload.success,
      };

    case DELETEFINANCESETUP:
      return {
        ...state,
        financeSetupList: state.financeSetupList.filter(
          (item) => item.id !== action.financeSetupId,
        ),
        financeSetupDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
